module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.674f50d.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@intelipost-modules/secure-ng/dist/fonts/fontawesome-webfont.eot
// module id = U6SH
// module chunks = 72